import { render, staticRenderFns } from "./planToExport.vue?vue&type=template&id=65dbbad0&scoped=true"
import script from "./planToExport.vue?vue&type=script&lang=js"
export * from "./planToExport.vue?vue&type=script&lang=js"
import style0 from "./planToExport.vue?vue&type=style&index=0&id=65dbbad0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dbbad0",
  null
  
)

export default component.exports